import _regeneratorRuntime from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { flattenedDecrypt } from '../flattened/decrypt.js';
import { JWEDecryptionFailed, JWEInvalid } from '../../util/errors.js';
import isObject from '../../lib/is_object.js';
export function generalDecrypt(_x, _x2, _x3) {
  return _generalDecrypt.apply(this, arguments);
}

function _generalDecrypt() {
  _generalDecrypt = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(jwe, key, options) {
    var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, recipient;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (isObject(jwe)) {
              _context.next = 2;
              break;
            }

            throw new JWEInvalid('General JWE must be an object');

          case 2:
            if (!(!Array.isArray(jwe.recipients) || !jwe.recipients.every(isObject))) {
              _context.next = 4;
              break;
            }

            throw new JWEInvalid('JWE Recipients missing or incorrect type');

          case 4:
            if (jwe.recipients.length) {
              _context.next = 6;
              break;
            }

            throw new JWEInvalid('JWE Recipients has no members');

          case 6:
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 9;
            _iterator = jwe.recipients[Symbol.iterator]();

          case 11:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context.next = 24;
              break;
            }

            recipient = _step.value;
            _context.prev = 13;
            _context.next = 16;
            return flattenedDecrypt({
              aad: jwe.aad,
              ciphertext: jwe.ciphertext,
              encrypted_key: recipient.encrypted_key,
              header: recipient.header,
              iv: jwe.iv,
              protected: jwe.protected,
              tag: jwe.tag,
              unprotected: jwe.unprotected
            }, key, options);

          case 16:
            return _context.abrupt("return", _context.sent);

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](13);

          case 21:
            _iteratorNormalCompletion = true;
            _context.next = 11;
            break;

          case 24:
            _context.next = 30;
            break;

          case 26:
            _context.prev = 26;
            _context.t1 = _context["catch"](9);
            _didIteratorError = true;
            _iteratorError = _context.t1;

          case 30:
            _context.prev = 30;
            _context.prev = 31;

            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }

          case 33:
            _context.prev = 33;

            if (!_didIteratorError) {
              _context.next = 36;
              break;
            }

            throw _iteratorError;

          case 36:
            return _context.finish(33);

          case 37:
            return _context.finish(30);

          case 38:
            throw new JWEDecryptionFailed();

          case 39:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 26, 30, 38], [13, 19], [31,, 33, 37]]);
  }));
  return _generalDecrypt.apply(this, arguments);
}